import makeStyles from '@mui/styles/makeStyles'
import Typography from '@mui/material/Typography'
import CardStation from 'components/CardStation'
import Layout from 'components/Layout'
import { getStationsByType, getStationTypes } from 'lib/stations'
import Head from 'next/head'

const useStyles = makeStyles((theme) => ({
  header: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  section: {
    marginBottom: theme.spacing(5)
  },
  sectionContent: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  card: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2)
  }
}))

export default function Stations ({ stationTypes }) {
  const classes = useStyles()

  return (
    <>
      <Head>
        <title>Sendung verpasst? Alle Sender</title>
        <meta name='description' content='Übersicht aller Sender bei Sendung verpasst?' />
      </Head>
      <Layout header={
        <div className={classes.header}>
          <Typography variant='h1' component='h1'>Alle Sender</Typography>
        </div>
      }
      >
        {stationTypes.map((stationType) => (
          <section key={stationType.key} className={classes.section}>
            <Typography gutterBottom variant='h2' component='h2' className={classes.sectionTitle}>{stationType.name}</Typography>
            <div className={classes.sectionContent}>
              {getStationsByType(stationType.key).map((station) => (
                <div key={station.slug} className={classes.card}>
                  <CardStation station={station} />
                </div>
              ))}
            </div>
          </section>
        ))}
      </Layout>
    </>
  )
}

export async function getStaticProps () {
  const stationTypes = getStationTypes()

  return {
    props: {
      stationTypes
    }
  }
}
